<template>
  <div v-bind:style="styles" class="print-container transition-all duration-100">
    <slot></slot>

    <div v-if="rulers && $root.showMoveHint" id="move-hint">
      Wist je dat je de kaart kan bewegen?
    </div>
  </div>
</template>

<script>
export default {
  name: "PrintContainer",

  props: {
    print: Object,

    rulers: {
      type: Boolean,
      default: true,
    },

    posterSize: {
      type: Object,
      default: () => ({
        width: 651,
        height: 920,
      }),
    },
  },

  data() {
    return {
      el: null,

      styles: {
        transform: 'scale(0)',
        visibility: 'hidden',
      },
    }
  },

  computed: {
    verticalSize() {
      if (this.$root.print.orientation === 'horizontal')
        return (this.$parent.currentSize.width / 10) + ' cm';

      return (this.$parent.currentSize.height / 10) + ' cm';
    },
    horizontalSize() {
      if (this.$root.print.orientation === 'horizontal')
        return (this.$parent.currentSize.height / 10) + ' cm';

      return (this.$parent.currentSize.width / 10) + ' cm';
    },
  },

  mounted() {
    this.el = this.$el;

    window.bus.$on('resize', () => {
      console.log('resize');

      const parentheight = this.innerDimensions(this.el.parentElement).height;
      const parentWidth = this.innerDimensions(this.el.parentElement).width;

      const scaleHeight = parentheight / this.el.offsetHeight;
      const scaleWidth = parentWidth / this.el.offsetWidth;

      this.styles.transform = `translate(-50%, 0) scale(${Math.min(scaleHeight, scaleWidth, 1)})`;
      this.styles.visibility = 'visible';

      if (this.printmode) {
        this.styles.transform = `translate(0,0) scale(8)`;
        this.styles['transform-origin'] = `top left`;
      }
    });

    window.onresize = () => {
      window.bus.$emit('resize')
    };
    window.bus.$emit('resize');

    // resize after a second just to be sure
    setTimeout(() => {
      this.$nextTick(() => {
        window.bus.$emit('resize');
      });
    }, 1000);

    this.parentHeight = this.$el.parentElement.offsetHeight;
    console.log(this.parentHeight);
  },

  methods: {
    innerDimensions: (node) => {
      const computedStyle = getComputedStyle(node);

      let width = node.clientWidth; // width with padding
      let height = node.clientHeight; // height with padding

      height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
      width -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
      return {height, width}
    }
  }
}
</script>

<style scoped lang="scss">
$padding: 100;

$paddingPx: $padding * 1px;
$rulerInset: ($padding - 30) * 1px;

$sizeLabelRight: 50px;
$sizeLabelBottom: 30px;

.print-container {
  padding: $paddingPx;
  position: absolute;
  top: 0;
  left: 50%;
  transform-origin: top center;
}

#move-hint {
  font-family: 'Shadows Into Light Two', cursive;
  font-size: 40px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
}
</style>